import { useEffect, useMemo } from "react";
import { useStore, useSettingsStore } from "../../store";
import { useTraceStore } from "./traceStore";
import Trace from "./Trace";
import ObserverTrace from "../Observer/ObserverTrace";

const TraceController = () => {
  const { settings } = useSettingsStore();
  const { trace, setTraceStart } = useTraceStore();
  const posRef = useStore((s) => s.posRef);

  // OPTIMIZATION: Filter settings directly from the store based on the new `traced` property.
  // No Leva UI logic needed here anymore!
  const checkedPlanets = useMemo(() => {
    return settings
      .filter((s) => {
        if (!s.traceable) return false;
        // Fallback to true if it's Mars and undefined
        return s.traced !== undefined ? s.traced : s.name === "Mars";
      })
      .map((s) => s.name);
  }, [settings]);

  useEffect(() => {
    if (trace) {
      setTraceStart(posRef.current);
    }
  }, [trace, setTraceStart]);

  return (
    <>
      <ObserverTrace />
      {checkedPlanets.map((item) => (
        <Trace name={item} key={item} />
      ))}
    </>
  );
};

export default TraceController;
